import { FileUtils } from "../../../../../common/utils/file_utils";
import { ICreateControlePatrimonioUseCase } from "../../../presentation/useCases/create/create_controle_patrimonio_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateControlePatrimonioUseCase
 */

export class CreateControlePatrimonioUseCase implements ICreateControlePatrimonioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createControlePatrimonio(
    idFuncionario: number,
    idMaquinaEquip: number,
    dataEntrega: Date | null,
    dataDevolucao: Date | null,
    observacoes: string | null,
    files: File | null,
  ): Promise<void> {
    await this.repository.createControlePatrimonio(
      idFuncionario,
      idMaquinaEquip,
      dataEntrega,
      dataDevolucao,
      observacoes,
      files ? await this.getFilename(files) : null,
      files,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }

  private async convertToBase64(file: File | null): Promise<string | null> {
    return await FileUtils.readFileAsBase64(file);
  }
}